export default "__VITE_ASSET__D7tG1IpO__"